<template>
    <section class="smart-portfolio">
        <div class="container">
            <h2 class="title _title">Наши реализованные проекты</h2>

            <VueSlickCarousel
                v-if="ready"
                :infinite="true"
                :dots="false"
                :speed="300"
                :slidesToShow="1"
                :arrows="false"
                class="smart-portfolio__block"
                @swipe.self="test"
            >
                <Slider
                    v-for="(item, key) in projects"
                    :key="key"
                    :uuid="`${key + 'big_slider'}`"
                    :name="item.name"
                    :previewImage="item.preview_url"
                    :text="item.text"
                    :images="item.portfolioImages"
                />
            </VueSlickCarousel>
        </div>
    </section>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Slider from "./UI/slider.vue";

export default {
    name: "SmartHomePortfolio",
    components: { VueSlickCarousel, Slider },
    data() {
        return {
            ready: false,
            settings: {
                slidesToShow: 2,
            },
            projects: [
                {
                    "id": 17,
                    "name": "Ресторан «Сарай»",
                    "url": "http://localhost/portfolio/restoran-saray",
                    "text": "Сезон красивых летних веранд в этом году однозначно увеличился, потому что мы поработали от души👍",
                    "preview_url": "/storage/4744/conversions/medialibrarykq4OMJ-preview.jpg",
                    "portfolioImages": [
                        "/storage/4739/conversions/1652692930-full.jpg",
                        "/storage/4740/conversions/1652692934-full.jpg",
                        "/storage/4741/conversions/1652692937-full.jpg"
                    ]
                },
                {
                    "id": 18,
                    "name": "Кофейня \"Чашка кофе\"",
                    "url": "http://localhost/portfolio/kofeynya-chashka-kofe",
                    "text": "В данном проекте для кофейни \"Чашка кофе\" мы установили маркизы, элегантно подчеркнув фасад здания.",
                    "preview_url": "/storage/4738/conversions/medialibraryMUggPT-preview.jpg",
                    "portfolioImages": [
                        "/storage/4734/conversions/1652692891-full.jpg",
                        "/storage/4735/conversions/1652692894-full.jpg",
                        "/storage/4736/conversions/1652692898-full.jpg"
                    ]
                },
            ],
        };
    },
    mounted() {
        this.getProjects().then((res) => {
            this.projects = res;
            this.ready = true;
        });
    },
    methods: {
        test () {
            console.log('daddy swipe', ...arguments);
        },

        async getProjects() {
            const response = await this.$http.get(
                '/api/slider/projects/smart-home'
            );


            /**
             * @todo add response validation
             */
            if (false) {
                return undefined;
            }

            const projects = response.body;
            return projects;
        },
    }
};
</script>
